import React from 'react'
import Card from 'react-bootstrap/Card'
export default class ArticleCell extends React.Component { 

	getImageStyle(url)  { 
		const divStyle = { 
			backgroundImage: `url(${url})`, 
			width:'100%', 
			height:'300px',
			backgroundSize: 'cover',
			backgroundPosition: 'center', 
			diplay: 'flex'
		}
		return divStyle
	}

	getCardStyle() { 
		const styles = {width: '80%', cursor: 'pointer'}
		if (this.props.horizontal) {
			styles.flex = '0 0 auto'
			styles.marginRight = "20px"
		}
		return styles
	}


	render() { 
		return (
			<Card style={this.getCardStyle()} onClick={() => this.props.onClicked(this.props.article.id)}>
   			 <div style={this.getImageStyle(this.props.article.image_url)}>
			    </div>
    		<Card.Body>
      		<Card.Title>{this.props.article.title}</Card.Title>
      		<Card.Text>
        		{this.props.article.subheading}
      		</Card.Text>
    		</Card.Body>
  			</Card>
			)
	}
}
